<!--
Author: TangChen
Date: 2018-09-05
Desc: 注册页面组件，由router.js 配置引入
-->
<template>
    <div class="view-outframe view">
        <header-com :tit="titText" />
        <div class="container">
            <router-view />
        </div>
        <log />
        <footer-com />
    </div>
</template>

<script>
import headerCom from "@/components/common/header.vue";
import footerCom from "@/components/common/footer.vue";
import log from "@/components/common/log.vue";

export default {
    components: {
        headerCom,
        footerCom,
        log
    },
    data () {
        return {
            titText: ""
        };
    },
    mounted () {
        if (this.$route.query && this.$route.query.tit) {
            this.titText = this.$route.query.tit;
        }
    }
};
</script>
